import { Counter } from "../atoms/Counter";
import { Eyebrow } from "../atoms/Eyebrow";
import { Reveal } from "../atoms/Reveal";
import type { Copy } from "../lib/copy";

type ROIProps = { t: Copy };

export function ROI({ t }: ROIProps) {
  return (
    <section id="roi" className="section roi">
      <div className="container">
        <div className="section-head wide">
          <Reveal>
            <Eyebrow>{t.roi.eyebrow}</Eyebrow>
          </Reveal>
          <Reveal as="h2" className="section-title" delay={60}>
            <span className="ink">{t.roi.title_a}</span>{" "}
            <span className="serif-accent">{t.roi.title_b}</span>
          </Reveal>
        </div>

        <div className="roi-grid">
          {t.roi.items.map((it, i) => (
            <Reveal key={i} className="roi-card" delay={i * 80}>
              <div className="rc-v">
                <Counter to={it.v} prefix={it.pre ?? ""} suffix={it.suf ?? ""} />
              </div>
              <div className="rc-l">{it.l}</div>
              <div className="rc-sub">{it.sub}</div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
